import Input, { CurrencyInput, MaskedInput } from 'components/Form/Input';
import PasswordValidation from 'components/Form/PasswordValidation';
import Select from 'components/Form/Select';
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { toast } from 'react-toastify';
import {
  ContentForm,
  ContentFormHeader,
  FormInput,
  FormSeparator,
  FormWrapper,
} from './styled';

/**
 * @param  ref - obrigatório
 * @param  formItems - obrigatório
 * @param  register - opcional
 * @param  disabled - opcional
 * @param  title - opcional
 */
export default forwardRef(function FormCore(
  { formItems, register, disabled, title },
  ref
) {
  const [form, setForm] = useState({});
  const formValue = useCallback(
    (ref) => {
      return form?.[ref] !== undefined && form?.[ref] !== null
        ? form?.[ref]
        : '';
    },
    [form]
  );
  const changeForm = (value, ref) => {
    setForm((prev) => ({ ...prev, [ref]: value }));
  };
  const [nextPrint, setNextPrint] = useState([]);

  useEffect(() => setForm(register), [register]);

  useEffect(() => setNextPrint(formItems), [formItems]);

  const valid = (payload, array) => {
    for (let item of array) {
      if (item?.ref && !payload?.[item?.ref] && item?.required) {
        //verifica se é zero
        if (payload?.[item?.ref] === 0) {
          continue;
        }
        toast.error(
          `O campo ${item?.label || item?.placeholder || item?.ref} é obrigatório.`
        );
        return false;
      }
      if (item?.ref && item?.validate && !item?.validate(payload)) {
        return false;
      }
    }
    return true;
  };

  useImperativeHandle(
    ref,
    useCallback(
      () => ({
        getForm(skip = false) {
          if (!valid(form, formItems) && !skip) {
            return;
          }
          return form;
        },
        setItem(value, item) {
          changeForm(value, item);
        },
        getItem(item) {
          let val = formValue(item);
          return val;
        },
      }),
      [form, formItems, formValue]
    )
  );

  // useImperativeHandle2(ref,useCallback(() => ({
  // }), [form]))
  // useImperativeHandle3(ref,useCallback(() => ({
  // }), [form]))

  return (
    <>
      <ContentForm active={!!title}>
        <ContentFormHeader active={!!title}>{title}</ContentFormHeader>
        <FormWrapper>
          {nextPrint.map(
            (item, key) =>
              !!item && (
                <>
                  {item.separator ? (
                    <FormSeparator />
                  ) : (
                    <FormInput
                      full={item.full}
                      half={item.half}
                      quarter={item.quarter}
                      twenty={item.twenty}
                      customWidthCalc={item.customWidthCalc}
                      key={key}
                      onBlur={item.onBlur}
                      required={item.required}
                      disabled={item.disabled}
                      min="0"
                      max="2"
                      transparent={item.transparent ?? true}
                    >
                      {item.custom ? (
                        item.custom
                      ) : item.options ? (
                        <Select
                          required={item.required}
                          placeholder={item.placeholder}
                          options={item.options}
                          value={formValue(item.ref)}
                          onChange={(val) => {
                            changeForm(val, item.ref);
                            if (typeof item.onChange === 'function') {
                              item.onChange(val);
                            }
                          }}
                          onBlur={() =>
                            typeof item?.onBlur === 'function'
                              ? item.onBlur(formValue(item.ref))
                              : null
                          }
                          disabled={item.disabled || disabled}
                          min="0"
                          transparent={item.transparent ?? true}
                        />
                      ) : item.mask ? (
                        <MaskedInput
                          Tooltip={item.Tooltip}
                          mask={item.mask}
                          placeholder={item.placeholder}
                          value={formValue(item.ref)}
                          onChange={(e) => {
                            const val = e.target.value;
                            changeForm(val, item.ref);
                            if (typeof item.onChange === 'function') {
                              item.onChange(val);
                            }
                          }}
                          onBlur={() =>
                            typeof item?.onBlur === 'function'
                              ? item.onBlur(formValue(item.ref))
                              : null
                          }
                          disabled={item.disabled || disabled}
                          required={item.required}
                          min="0"
                          transparent={item.transparent ?? true}
                        />
                      ) : item.type === 'cpf' ? (
                        <MaskedInput
                          Tooltip={item.Tooltip}
                          mask={
                            formValue('tcc2') === 'juridica'
                              ? '99.999.999/9999-99'
                              : '999.999.999-99'
                          }
                          type={item.type}
                          placeholder={item.placeholder}
                          value={formValue(item.ref)}
                          onChange={(e) => {
                            const val = e.target.value;
                            changeForm(val, item.ref);
                            if (typeof item.onChange === 'function') {
                              item.onChange(val);
                            }
                          }}
                          onBlur={() =>
                            typeof item?.onBlur === 'function'
                              ? item.onBlur(formValue(item.ref))
                              : null
                          }
                          disabled={item.disabled || disabled}
                          required={item.required}
                          min="0"
                          transparent={item.transparent ?? true}
                        />
                      ) : item.type === 'money' ? (
                        <CurrencyInput
                          mask={item.mask}
                          type={item.type}
                          placeholder={item.placeholder}
                          value={item.value ?? formValue(item.ref)}
                          onChange={(e) => {
                            const val = e.target.value;
                            changeForm(val, item.ref);
                            if (typeof item.onChange === 'function')
                              item.onChange(val);
                          }}
                          onBlur={() =>
                            typeof item?.onBlur === 'function'
                              ? item.onBlur(formValue(item.ref))
                              : null
                          }
                          disabled={item.disabled || disabled}
                          required={item.required}
                          readOnly={item.readOnly}
                          min="0"
                          transparent={item.transparent ?? true}
                          style={item.style}
                        />
                      ) : item.passwordValidation ? (
                        <PasswordValidation
                          password={form.password}
                          transparent={item.transparent}
                        />
                      ) : (
                        <Input
                          type={item.type}
                          placeholder={item.placeholder}
                          value={formValue(item.ref)}
                          onChange={(e) => {
                            const val = e.target.value < 0 ? 0 : e.target.value;
                            changeForm(val, item.ref);
                            if (typeof item.onChange === 'function')
                              item.onChange(val);
                          }}
                          disabled={item.disabled || disabled}
                          onBlur={() =>
                            typeof item?.onBlur === 'function'
                              ? item.onBlur(formValue(item.ref))
                              : null
                          }
                          endIcon={item?.search}
                          required={item.required}
                          min="0"
                          max="2"
                          height={item?.height}
                          maxRows={item?.maxRows}
                          multiline={item.multiline}
                          transparent={item.transparent ?? true}
                        />
                      )}
                    </FormInput>
                  )}
                </>
              )
          )}
        </FormWrapper>
      </ContentForm>
    </>
  );
});
